import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
    resetForm: FormGroup;
    token: string = '';
    hide = true;
    loading = false;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private snackBar: MatSnackBar
    ) {
        this.resetForm = this.fb.group({
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        // URLからトークンを取得
        this.token = this.route.snapshot.queryParams['token'];
        if (!this.token) {
            this.snackBar.open('Invalid token.', 'Close', { duration: 3000 });
            this.router.navigate(['/login']);
        }
    }

    onSubmit(): void {
        if (this.resetForm.invalid) return;

        const { password, confirmPassword } = this.resetForm.value;
        if (password !== confirmPassword) {
            this.snackBar.open('Passwords do not match.', 'Close', { duration: 3000 });
            return;
        }

        this.loading = true;
        this.authService.confirmPasswordReset(this.token, password).subscribe({
            next: () => {
                this.snackBar.open('Password reset successful. Please login.', 'OK', { duration: 5000 });
                this.router.navigate(['/login']);
            },
            error: (err) => {
                this.loading = false;
                console.error(err);
                this.snackBar.open(err.error.detail || 'Failed to reset password.', 'Close', { duration: 3000 });
            }
        });
    }
}